import React from 'react';
import { Modal, Button, Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class PreviewModal extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
        pagination: {
            pageSize: 5,
            current: 1,
        },
    }

    show = record => {
        this.setState({
            record,
            data: [],
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { record: { ssuStructureLogId }, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryBySsuStructureLogId,
            data: {
                offset: current,
                limit: pageSize,
                ssuStructureLogId,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.logDetailList,
                    loading: false,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    }

    updateImgUrl = (src) => {
        this.props.updateImgUrl(src);
    }

    downLoadFile = (id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId: id }, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: '更新字段',
        dataIndex: 'ssuModuleStructureDefineName',
        key: 'ssuModuleStructureDefineName',
        width: 130,
    }, {
        title: '更新前',
        dataIndex: 'oldValue',
        key: 'oldValue',
        width: 185,
        render: (text, record) => {
            let result = text;
            const { valueType, oldFileMetaList } = record;
            if ((valueType == 'FLOW_CHART') && text) {
                result = <img style={{ width: 175, border: '1px solid #d1d1d1', cursor: 'pointer' }} src={text} onClick={() => this.updateImgUrl(text)} />
            } else if ((valueType == 'ATTACHMENT') && oldFileMetaList) {
                result = oldFileMetaList.map(i => <p key={i.id}><a onClick={() => this.downLoadFile(i.id)}>{i.name}</a></p>);
            }
            return result;
        }
    },
    {
        title: '更新后',
        dataIndex: 'newValue',
        key: 'newValue',
        width: 185,
        render: (text, record) => {
            let result = text;
            const { valueType, newFileMetaList } = record;
            if ((valueType == 'FLOW_CHART') && text) {
                result = <img style={{ width: 175, border: '1px solid #d1d1d1', cursor: 'pointer' }} src={text} onClick={() => this.updateImgUrl(text)} />
            } else if ((valueType == 'ATTACHMENT') && newFileMetaList) {
                result = newFileMetaList.map(i => <p key={i.id}><a onClick={() => this.downLoadFile(i.id)}>{i.name}</a></p>);
            }
            return result;
        }
    }
    ]

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = (data || []).map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filter, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { record, visible, loading } = this.state;
        const { createTimeShow, createUserName, createUserCode } = record;
        //人员ID为0的日志无工号（系统自动产生），不显示空括号
        const updateUserShow = createUserCode ? `${createUserName}(${createUserCode})` : createUserName;
        return (
            <Modal
                title="查看更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal inv-detail"
                wrapClassName="vertical-center-modal"
                width="640px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ background: '#fff', padding: '10px 30px' }}>
                    <div className="filter-bar">
                        <div className="filter-bar-investigation" style={{ width: '100%' }}>
                            <p style={{ float: 'left', color: "rgba(0, 0, 0, 0.85)" }}>
                                更新日期：{createTimeShow} <span> | </span> 更新者：{updateUserShow}
                            </p>
                        </div>
                    </div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                        loading={loading}
                        onChange={this.handleTableChange}
                        scroll={{ x: 560, y: 300 }}
                        pagination={false}
                    />
                </div>
            </Modal>
        );
    }
}

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/components/hospital/ssuLog/PreviewModal.js